
const digest = '52a2f10746deb7b0d08a8ba93ce4008a42b5d6352a7a7f40d268e5b344ded72f';
const classes = {"wrapper":"_wrapper_xdci1_1","input":"_input_xdci1_5","fakeInput":"_fakeInput_xdci1_9","placeholder":"_placeholder_xdci1_33","fileName":"_fileName_xdci1_41","button":"_button_xdci1_49","invalid":"_invalid_xdci1_64","errorMessage":"_errorMessage_xdci1_68"};
const css = `._wrapper_xdci1_1 {
  margin-bottom: 10px;
}

._input_xdci1_5 {
  display: none;
}

._fakeInput_xdci1_9 {
  height: auto !important;
  border: 1px solid #e2e5ed;
  min-height: 55px;
  max-height: 55px;
  font-family: Rubik, sans-serif;
  font-size: 14px;
  font-weight: 400;
  border-right: 0;
  border-radius: 24.5px;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  padding: 10px 0 10px 20px;
  color: #000;
  background-color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
._fakeInput_xdci1_9:focus {
  box-shadow: 0 0 0 3px rgba(22, 101, 216, 0.15), inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
  border-color: #1665d8;
  color: #000;
}
._fakeInput_xdci1_9 ._placeholder_xdci1_33 {
  color: #9ea0a5;
  font-size: 14px;
  height: 55px;
  display: flex;
  position: relative;
  padding: 15px 0;
}
._fakeInput_xdci1_9 ._fileName_xdci1_41 {
  color: #000000;
  font-size: 14px;
  height: 55px;
  display: flex;
  position: relative;
  padding: 15px 0;
}
._fakeInput_xdci1_9 ._button_xdci1_49 {
  color: #1665d8;
  display: flex;
  height: 55px;
  border-left: 1px #e2e5ed solid;
  padding: 16px 20px;
  font-weight: 500;
  border-top-right-radius: 24.5px;
  border-bottom-right-radius: 24.5px;
}
._fakeInput_xdci1_9 ._button_xdci1_49:hover {
  background-color: #1665d8;
  color: #ffffff;
}

._invalid_xdci1_64 {
  border-color: #d81616 !important;
}

._errorMessage_xdci1_68 {
  font-family: Rubik, "sans-serif";
  font-size: 14px;
  color: #d81616;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  